import moment from 'moment'

moment.locale('es')

class EventFilterService {
  static getFilters (params) {
    let filters = {
      active: this.getStorageActive(),
      lesson: this.getStorageLesson(),
      gender: this.getStorageGender(),
      level_status: this.getStorageLevelStatus(),
      age_from: this.getStorageAgeFrom(),
      age_to: this.getStorageAgeTo(),
      rider_id: this.getStorageRider()
    }

    if (params) {
      if (params.active && Number.isInteger(parseInt(params.active))) {
        filters.active = params.active
      }
      if (params.lesson && Number.isInteger(parseInt(params.lesson))) {
        filters.lesson = params.lesson
      }
      if (params.gender) {
        filters.gender = params.gender
      }
      if (params.level_status) {
        filters.level_status = params.level_status
      }
      if (params.age_from && Number.isInteger(parseInt(params.age_from))) {
        filters.age_from = params.age_from
      }
      if (params.age_to && Number.isInteger(parseInt(params.age_to))) {
        filters.age_to = params.age_to
      }
      if (params.rider_id && Number.isInteger(parseInt(params.rider_id))) {
        filters.rider_id = params.rider_id
      }
    }
    return filters
  }

  static setStorageFilters (filters) {
    let data = {
      'lastSave': moment().format('YYYY-MM-DD'),
      ...filters
    }
    localStorage.setItem('horseFilters', JSON.stringify(data))
  }

  static getStorageFilters () {
    let filters = JSON.parse(localStorage.getItem('horseFilters'))
    let currentDay = moment().format('YYYY-MM-DD')
    return !filters || filters.lastSave !== currentDay ? null : filters
  }

  static getStorageActive () {
    let filters = this.getStorageFilters()
    return filters && filters.active ? filters.active : 'all'
  }

  static getStorageLesson () {
    let filters = this.getStorageFilters()
    return filters && filters.lesson ? filters.lesson : 0
  }

  static getStorageGender () {
    let filters = this.getStorageFilters()
    return filters && filters.gender ? filters.gender : 'all'
  }

  static getStorageLevelStatus () {
    let filters = this.getStorageFilters()
    return filters && filters.level_status ? filters.level_status : 'all'
  }

  static getStorageAgeFrom () {
    let filters = this.getStorageFilters()
    return filters && filters.age_from ? filters.age_from : 1
  }

  static getStorageAgeTo () {
    let filters = this.getStorageFilters()
    return filters && filters.age_to ? filters.age_to : 30
  }

  static getStorageRider () {
    let filters = this.getStorageFilters()
    return filters && filters.rider_id ? filters.rider_id : null
  }
}

export default EventFilterService
